// import {useEffect} from "react";
// import anime from "animejs";
// import animation from './JSON/ejemplo.json'
// import ReactBodymovin from 'react-bodymovin/lib/ReactBodymovinFull'
// import ReactBodymovin from 'react-bodymovin'
import "./Blob1.scss";
import blobVideo from '../video/blob_01.mp4'

function Blob1() {

    /*const bodymovinOptions = {
        loop: true,
        autoplay: true,
        prerender: true,
        render: 'svg',
        animationData: animation
    }

    return (
        <div className={'container-animation blob-1'}>
            <ReactBodymovin options={bodymovinOptions} />
        </div>
    )*/

    return (
        <div className={'container-animation blob-1'}>
            <video autoPlay loop muted playsInline>
                <source src={blobVideo} type="video/mp4"/>
            </video>
        </div>
    );
}

export default Blob1;
